<template>
  <div class="zw-product-four-template">
    <!--    背景图-->
    <div
      :style="{backgroundImage:'url('+ bgImgUrl +')'}"
      class="zw-four-bg"
    >
      <div class="zw-four-bg-tile">
        <div>公安局智慧政工综合管理平台</div>
        <span>智慧政工，赋能公安队伍建设</span>
      </div>
    </div>
    <div class="zw-four-bg-introduc">
      <div
        style="display: flex;justify-content: center;align-items: center;
        margin-bottom: 20px"
      >
        <img src="../../assets/image/product/fourLeft.png" alt="">
        <div
          style="font-size: 28px;font-weight: bold;color: #000000;
         padding: 0 20px"
        >系统简介</div>
        <img src="../../assets/image/product/fourRight.png" alt="">
      </div>
      <div
        style="display: flex;padding: 50px 0 0;width: 100%;
      justify-content: center;flex-direction: column"
      >
        <div
          style="font-size: 16px;color: #000000;
        line-height: 26px"
        >
          “公安局智慧政工管理系统”是以数据为核心，以智能为驱动，打通人事、培训、考核等业务数据链条，构建警员全生命周期管理体系，实现队伍状态可感知、人员能力可评估、职业发展可规划、选人用人可支撑，推动政工管理从“经验判断”向“科学决策”转变，全面提升公安队伍管理效能。        </div>
        <el-divider />
      </div>
    </div>
    <div class="zw-four-bg-trait">
      <div
        style="display: flex;justify-content: center;align-items: center;
        margin-bottom: 20px"
      >
        <img src="../../assets/image/product/fourLeft.png" alt="">
        <div
          style="font-size: 28px;font-weight: bold;color: #000000;
          padding: 0 20px"
        >系统特点</div>
        <img src="../../assets/image/product/fourRight.png" alt="">
      </div>
      <div class="zw-trait-context">
        <ul>
          <li v-for="(item, index) in traitList" :key="index">
            <el-card style="width: 100%" shadow="always">
              <div style="display: flex;align-items: center;width: 100%;justify-content: space-between;">
                <div style="text-align: center;padding-right: 20px;">
                  {{ item.text }}
                </div>
                <img :src="item.imgUrl" width="100px" height="100px" alt="">
              </div>
            </el-card>
          </li>
        </ul>
      </div>
    </div>
    <!--免费获取方案-->
    <div
      :style="{backgroundImage:'url('+ fontImg +')'}"
      class="zw-four-footer"
    >
      <div
        style="display: flex;align-items: center;height: 100%;
      justify-content: center;flex-direction: column"
      >
        <div style="font-size: 28px;font-weight: bold;color: #000000;padding-bottom: 30px">
          即刻为你的企业定制解决方案
        </div>
        <el-button size="small" type="primary" @click="handleProgramme">免费获取方案</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HumanResources',
  data() {
    return {
      bgImgUrl: require('../../assets/image/product/fourBg.jpg'),
      fontImg: require('../../assets/image/product/fourfoot.jpg'),
      traitList: [
        {
          imgUrl: require('../../assets/image/product/four01.png'),
          text: '全生命周期警员数字档案场景：\n' +
              '为每位警员建立动态成长的“数字孪生档案”，让队伍底数清、情况明;'
        },
        {
          imgUrl: require('../../assets/image/product/four02.png'),
          text: '精准化岗位胜任力评估场景：\n' +
              '通过数据模型智能匹配人与岗，让关键岗位“找对人”、能者“上位快”;'
        },
        {
          imgUrl: require('../../assets/image/product/four03.png'),
          text: '个性化职业发展规划场景：\n' +
              '为警员定制专属成长路线和学习套餐，让职业前景“看得见”、进步“有奔头”;'
        },
        {
          imgUrl: require('../../assets/image/product/four04.png'),
          text: '全链条队伍风险预警场景：\n' +
              '实时监测异常指标自动亮灯预警，让队伍隐患“早发现”、关爱“早介入”。'
        }
      ]
    }
  },
  methods: {
    // 免费获取方案
    handleProgramme() {
      this.$router.push({
        path: '/getScheme'
      })
    }
  }
}
</script>

<style scoped>

</style>
